// FIXME: ADD REAL PERMISSIONS
export default [{
  path: '/bookings_options',
  name: 'booking-options',
  meta: {
    modelName: 'Opciones de Reservas',
    needGuard: true,
    modules: ['reservations']
  },
  component: function component() {
    return import('@/modules/booking-options/BookingOptions.vue');
  }
}];